enum Fields {
    FirstName = 'firstName',
    LastName = 'lastName',
    Email = 'email',
    PhoneNumber = 'phoneNumber',
    BrokerageName = 'brokerageName'
}

export default Fields;
